import { L as LICENSE_MIN_PRICE, a as LICENSE_MAX_PRICE, e as GLIMMR_SECRET_KEY } from "./private.js";
import { e as error } from "./index2.js";
import range from "lodash/range.js";
import admin from "firebase-admin";
import * as cheerio from "cheerio";
process.env.NODE_ENV === "production";
const isDevelopment = process.env.NODE_ENV === "development";
const getPriceRange = () => range(Number(LICENSE_MIN_PRICE), Number(LICENSE_MAX_PRICE) + 1);
const handleRequest = (handler, secure = true) => {
  return async (event) => {
    const { request } = event;
    const secret = request.headers.get("X-Glimmr-Secret-Key") || event.url.searchParams.get("key");
    event.locals.secret = secret;
    if (secure && !secret) {
      error(403, {
        message: "Unauthorized"
      });
    }
    if (secure && secret) {
      if (secret !== GLIMMR_SECRET_KEY) {
        const response = await event.fetch(`/api/users/${secret}`);
        if (!response.ok) {
          error(403, {
            message: "Unauthorized"
          });
        }
        event.locals.user = await response.json();
      }
    }
    return handler(event);
  };
};
const getUserCount = async () => {
  const result = admin.firestore().collection("users").count();
  const count = await result.get();
  return count.data().count;
};
const getTrustPilotInfo = async () => {
  const response = await fetch("https://www.trustpilot.com/review/glimmr.app");
  const html = await response.text();
  const $ = cheerio.load(html);
  const data = $("div[data-rating-component='true']").first();
  const bannerImageUrl = data.find("img").attr("src");
  const rating = data.find("*[data-rating-typography='true']").text();
  const logoImageUrl = $("a[name='company-logo']").children().first().attr("src");
  return { logoImageUrl, bannerImageUrl, rating };
};
export {
  getUserCount as a,
  getTrustPilotInfo as b,
  getPriceRange as g,
  handleRequest as h,
  isDevelopment as i
};
